import { FilterField, labelId } from "kontrolEdge/helpers/advancedFilters";
import {
  bbConnectorServiceSubscriptionId,
  formatBbConnectorConnectedServiceTypeLabel,
  formatBbConnectorServiceDetail,
  type BbConnectorListItem,
} from "../../requests/request";

/** Type label for filter/display (matches Type column formatting). */
export function connectorTypeLabel(row: BbConnectorListItem): string {
  return formatBbConnectorConnectedServiceTypeLabel(row);
}

export function makeConnectorFields(): FilterField<BbConnectorListItem>[] {
  const fields: FilterField<BbConnectorListItem>[] = [
    {
      label: "Type",
      key: "type",
      accessor: (r) => connectorTypeLabel(r),
      type: "string",
      inFreeText: true,
    },
    {
      label: "Connector",
      key: "connector",
      accessor: (r) => {
        const d = r.connectedServiceDetail;
        const fromDetail =
          d && typeof d === "object"
            ? [
                d.subscriptionId != null ? String(d.subscriptionId) : "",
                d.name != null ? String(d.name) : "",
              ]
            : [];
        return [
          ...fromDetail,
          bbConnectorServiceSubscriptionId(r),
          formatBbConnectorServiceDetail(r.connectedServiceDetail),
          r.name,
          r.subscriptionId ?? "",
        ]
          .filter((s) => s != null && String(s).trim() !== "")
          .join(" ");
      },
      type: "string",
      inFreeText: true,
    },
    {
      label: "Location",
      key: "location",
      accessor: (r) => r.location?.displayName ?? "",
      type: "string",
      inFreeText: true,
    },
    {
      label: "VRF",
      key: "vrf",
      accessor: (r) => r.vrf?.displayName ?? "",
      type: "string",
      inFreeText: true,
    },
    {
      label: "VLAN",
      key: "vlan",
      accessor: (r) => String(r.vlan ?? ""),
      type: "string",
      inFreeText: true,
    },
    {
      label: "BGP",
      key: "bgp",
      accessor: (r) => (r.bgpStatus?.isEstablished ? "Up" : "Down"),
      type: "string",
      inFreeText: true,
    },
  ];
  for (const f of fields) f.key ??= labelId(f.label);
  return fields;
}
